var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map_container"},[_c('div',{staticClass:"map_content"},[_c('GoogleMapLoader',{attrs:{"api-key":"AIzaSyBSOAeIeop-ZGLWrZYB7fXZt2z33QA0fgM","map-config":_vm.mapConfig},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
var infowindow = ref.infowindow;
return [_c('span',_vm._l((_vm.getMarkers),function(marker){return _c('GoogleMapMarker',{key:marker.id,attrs:{"marker":marker,"google":google,"map":map,"infowindow":infowindow,"showPoint":_vm.whichPoint}})}),1)]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }